<template>
  <SelectWithSearch
    label="Forma de Pagamento"
    labelBusca="name"
    placeholder="Pesquise a forma de pagamento"
    v-model="input"
    :change="change"
    :options="paymentCollection"
    :disabled="disabled"
  >
    <template slot="options" slot-scope="props">
      <div class="selected">{{ props.data.name }}</div>
    </template>
    <template slot="no-options">Nenhuma forma encontrada</template>
    <template slot="selected" slot-scope="props">
      <div class="selected">{{ props.data.name }}</div>
    </template>
  </SelectWithSearch>
</template>

<script>
import { SelectWithSearch } from '@/components/Form';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'SelectPayment',
  components: {
    SelectWithSearch,
  },
  props: {
    value: {},
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      input: null,
    };
  },
  async mounted() {
    await this.setPaymentCollection();
  },
  computed: {
    ...mapState('payment', ['paymentCollection']),
  },
  methods: {
    ...mapActions('payment', ['setPaymentCollection']),

    change(value) {
      this.$emit('input', value);
      this.$emit('change', value);
    },
  },
  watch: {
    value(current) {
      this.input = current;
    },
  },
};
</script>
